import './WideMode.scss';

export const WideMode = ({ left, right }) => {
    return (
        <div className="WideMode">
            <div className="left">
               {left}
            </div>
            <div className="right">
                {right}
            </div>
        </div>
    );
};